module.exports = "../images/hero-logo-v2@2x.png?v=4c17c0c";